import React, { useEffect, useRef } from "react";
import "./PathwaySection.css";

// Image
import pathwayImg from "../../Assets/images/pathway.jpg";

const PathwaySection = () => {
  const imageRef = useRef(null);

  // Parallax scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (!imageRef.current) return;
      const scrollY = window.scrollY;
      imageRef.current.style.transform = `translateY(${scrollY * 0.05}px)`; 
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="pathway-section">
      <div className="pathway-container">
        {/* LEFT TEXT COLUMN */}
        <div className="pathway-content">
          <h2 className="pathway-title">Your Soul is the Record</h2>

          <div className="soundwave"></div>

          <p className="pathway-subtitle">Time is the Needle</p>

          <p className="pathway-text">
            Through soul-stirring music, evocative storytelling, and human
            emotion, Journeyman explores themes of resilience, purpose, and
            self-discovery. It challenges us to step beyond the familiar,
            confront the echoes of our past, and embrace the power of
            transformation.
          </p>
        </div>

        {/* RIGHT IMAGE COLUMN */}
        <div className="pathway-visual">
          <img
            ref={imageRef}
            src={pathwayImg}
            alt="performance"
            className="pathway-image"
          />
        </div>
      </div>
    </section>
  );
};

export default PathwaySection;